import React from 'react';
import {
  Link,
  Outlet,
  createRootRoute,
  createRoute,
  createRouter,
  RouterProvider,
} from '@tanstack/react-router';
import { TrackList } from './TrackList';
import { AdminPage } from './AdminPage';

const logoUrl = new URL('./assets/logo.png', import.meta.url).href;

const rootRoute = createRootRoute({
  component: () => (
    <div className="flex flex-col items-center min-h-screen font-sans bg-[#292d6e]">
      <nav className="w-full bg-white shadow-md p-4">
        <div className="max-w-6xl mx-auto flex justify-center items-center">
          <Link to="/" aria-label="Home">
            <img
              src={logoUrl}
              alt="Must Have Music"
              className="h-30 w-auto"
            />
          </Link>
        </div>
      </nav>
      <Outlet />
    </div>
  ),
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: TrackList,
});

const adminRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin',
  component: AdminPage,
});

const routeTree = rootRoute.addChildren([indexRoute, adminRoute]);
const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export default function App() {
  return <RouterProvider router={router} />;
}
